import {
  listPendingRecordings,
  type PendingRecording,
} from "@transcription/recordingStore";
import { create } from "zustand";

export type FailedRecording = Pick<PendingRecording, "id" | "createdAt">;

interface FailedRecordingsState {
  failed: FailedRecording[];
  refresh: () => Promise<void>;
}

const toFailed = (rec: PendingRecording): FailedRecording => ({
  id: rec.id,
  createdAt: rec.createdAt,
});

export const useFailedRecordingsStore = create<FailedRecordingsState>(
  (set) => ({
    failed: [],
    refresh: async () => {
      const pending = await listPendingRecordings();
      set({ failed: pending.filter((r) => r.failed).map(toFailed) });
    },
  }),
);

export const refreshFailedRecordings = (): Promise<void> =>
  useFailedRecordingsStore.getState().refresh();
